import { Directive, ElementRef, HostListener, Renderer2, ComponentRef, ViewContainerRef, ComponentFactoryResolver, Input, TemplateRef } from '@angular/core';
import { TooltipComponent } from '@app/shared/tooltip/tooltip.component';

@Directive({
    selector: '[appTooltip]',
    standalone: false
})
export class TooltipDirective {
  @Input('appTooltip') tooltipTemplate!: TemplateRef<any>;
  @Input('tooltipData') tooltipData: any;
  private tooltipRef: ComponentRef<TooltipComponent> | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2, private vcr: ViewContainerRef, private cfr: ComponentFactoryResolver) {}

  @HostListener('mouseover')
  onMouseEnter() {
    const factory = this.cfr.resolveComponentFactory(TooltipComponent);
    this.tooltipRef = this.vcr.createComponent(factory);

    this.tooltipRef.instance.tooltipTemplate = this.tooltipTemplate;
    this.tooltipRef.instance.tooltipData = this.tooltipData;

    const hostPos = this.el.nativeElement.getBoundingClientRect();
    const tooltipEl = this.tooltipRef.location.nativeElement;
    const tooltipDims = tooltipEl.getBoundingClientRect();

    const top = hostPos.top - tooltipDims.height - 10;
    const left = hostPos.left + hostPos.width / 2 - tooltipDims.width / 2;

    const viewportWidth = window.innerWidth;

    let adjustedTop = Math.max(10, top);
    let adjustedLeft = Math.max(10, Math.min(left, viewportWidth - tooltipDims.width - 10));

    this.renderer.setStyle(tooltipEl, 'position', 'fixed');
		this.renderer.setStyle(tooltipEl, 'top', `${adjustedTop}px`);
		this.renderer.setStyle(tooltipEl, 'left', `${adjustedLeft}px`);
		this.renderer.setStyle(tooltipEl, 'z-index', '1000');

    this.tooltipRef.instance.show();
  }

  @HostListener('mouseout')
  onMouseLeave() {
    this.renderer.removeChild(this.el.nativeElement, this.tooltipRef.location.nativeElement);
    this.tooltipRef = null;
  }
}
